module.exports = {"name":"--pf-c-tooltip--MaxWidth","value":"18.75rem","var":"var(--pf-c-tooltip--MaxWidth)"}
